/* eslint-disable react/prop-types */
import React from 'react';
import { useDispatch } from 'react-redux';
import { Modal } from 'semantic-ui-react';
import { closeModal } from '../../../redux/modals/modalReducer';

const ModalWrapper = ({ children, size, header }) => {
  const dispatch = useDispatch();
  return (
    // eslint-disable-next-line react/jsx-boolean-value
    <Modal open={true} onClose={() => dispatch(closeModal())} size={size}>
      {header && <Modal.Header>{header}</Modal.Header>}
      <Modal.Content>{children}</Modal.Content>
    </Modal>
  );
};
export default ModalWrapper;
